import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';
import { formatDate, formatNumber } from '../../helper/data-formatters.helper';

export const contractRatesGridColumns: Array<TableColumn> = [
  {
    id: 'shopCode',
    label: 'Shop Code',
    sortDisabled: true,
  },
  {
    id: 'repairCode',
    label: 'Repair Code',
    sortDisabled: true,
  },
  {
    id: 'repairDescription',
    label: 'Repair Description',
    sortDisabled: true,
  },
  {
    id: 'repairMode',
    label: 'Mode',
    sortDisabled: false,
  },
  {
    id: 'currencyCode',
    label: 'Currency',
    sortDisabled: true,
  },
  {
    id: 'maxMaterialPrice',
    label: 'Amount Local',
    dataType: {
      type: 'number',
      formatter: formatNumber,
    },
    sortDisabled: true,
  },
  {
    id: 'maxMaterialPriceUSD',
    label: 'Amount in USD',
    dataType: {
      type: 'number',
      formatter: formatNumber,
    },
    sortDisabled: false,
  },
  {
    id: 'effectiveDate',
    label: 'Effective Date',
    dataType: {
      type: 'string',
      formatter: formatDate,
    },
    sortDisabled: false,
  },
  {
    id: 'expiryDate',
    label: 'Expiry Date',
    dataType: {
      type: 'string',
      formatter: formatDate,
    },
    sortDisabled: false,
  },
  {
    id: 'actions',
    label: '',
    sortDisabled: true,
  },
];
